import React from 'react'
import HealthInformation from './HealthInformation'

export default function Life () {
  return <HealthInformation path='life' />
}